import request from '/src/router/axios'
export function getConsultById(query) {
    return request({
        url: '/admin/consult/home/details',
        method: 'get',
        params: query
    })
}